import { z } from 'zod';

// 02.7-settings.md paso a′ -- `UserProfilePanel.jsx`'s CRM contact lookup (§4). `z.looseObject`,
// `.parse()` (nunca `.safeParse()`), mismo criterio que el resto del repo. Verificado contra
// `PgContactRepository.getContactByPhone`/`getContactById` (backend/src/contacts/infrastructure/
// PgContactRepository.js) y `contactsRouter.js`.

const nullish = (schema) => schema.nullish();

export const ContactSchema = z.looseObject({
    id: z.union([z.string(), z.number()]),
    account: nullish(z.string()),
    name: nullish(z.string()),
    company: nullish(z.string()),
    emails: nullish(z.array(z.string())),
    phones: nullish(z.array(z.string())),
    spaces: nullish(z.array(z.union([z.string(), z.number()]))),
    tags: nullish(z.array(z.string())),
    avatar_url: nullish(z.string()),
    created_at: nullish(z.string()),
});

// `GET`/`PUT /api/contacts/by-phone/:phone` -- el `GET` devuelve 404 con `{success:false,
// error}` cuando el contacto no existe todavía (caso normal, no un error a tratar como bug).
export const ContactResponseSchema = z.looseObject({
    success: z.boolean(),
    contact: nullish(ContactSchema),
    error: nullish(z.string()),
});
